<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-50">
      <div class="container">
        <div class="area_wrap">
          <div id="map"></div>
          <div class="text_wrap normal">
            <div class="tw_item">
              <h2>땡큐서울의원의원</h2>
              <h3>서울특별시 강남구 테헤란로 408</h3>
              <h3>대치빌딩 4,5,6층</h3>
            </div>
            <div class="tw_item">
              <div class="tw_flex">
                <div class="item_img">
                  <img src="@/assets/images/gill1.svg">
                </div>
                <div class="item_text">
                  <h3>오시는 길</h3>
                </div>
              </div>
              <div class="item_text_sub">
                <div class="tw_pWrap">
                  <p>지하철 2호선/분당선 선릉역 1번 출구 바로앞(누네안과병원 건물)입니다.</p>
                  <p>현관으로 들어오셔서 가장 가까운 위치에 있는 엘리베이터(10층 이하 저층 전용)를 이용하셔야 합니다.</p>
                </div>
                <div class="tw_pWrap">
                  <p>테헤란로는 상습 정체구역으로 가급적 대중교통을 이용하시기 바랍니다.</p>
                  <p>*지방에서 열차로 오시는 분</p>
                  <p>-SRT 수서역에서 수인분당선 지하철로 선릉역 하차 (12분 거리)</p>
                  <p>-불가피하게 KTX를 타시는 분은 서울역에서 하차 후, 지하철 4호선-사당역에서 환승-2호선 선릉역 하차 (35-40분 소요)</p>
                </div>
                <div class="tw_pWrap">
                  <p>주차장은 건물 뒤편에 있고, 내비게이션에서 '땡큐서울의원'으로 검색하시면 됩니다.</p>
                </div>
                <!-- <div class="tw_pWrap">
                  <p>**주차 상세안내**</p>
                  <p>승용차 이용시 내비게이션은 "선릉역 7번출구"로 검색하고 오시면 발렛
                    주차장 있습니다. 7번 출구 표시 기둥과 7번 출구 계단 사이의 작은 공간으로
                    들어 오시면 발렛 주차 해드립니다.</p>
                  <p>(주차장 입구 사진 참조)</p>
                </div>-->
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_flex">
                <div class="item_img">
                  <img src="@/assets/images/gill2.svg">
                </div>
                <div class="item_text">
                  <h3>주차정보</h3>
                </div>
              </div>
              <div class="item_text_sub">
                <p class="tw_pWrap">
                  주차장 찾기: 승용차 이용시 내비게이션은
                  "땡큐서울의원"으로 검색하고 오시면
                  건물 뒷편 주차장 입구('누네안과병원 주차장')가 있습니다.
                </p>
              </div>
              <div class="item_text_sub">
                <p class="tw_pWrap">
                  선릉역 1번 출구를 지나 -> 우측 버스 정류장을 지나서 -> 우측 공항버스 정류장을 기준으로 우회전 -> 금강타워 주차장 지나서 -> 마디로한의원 기준 우회전(골목으로 들어오세요) -> 누네안과병원주차장 표지판 확인 후 주차하시면 됩니다.
                </p>
              </div>
              <div class="item_text_sub">
                <p class="tw_pWrap">
                  주차 가능 차량은 길이 5,160mm 이하, 너비 2,050mm 이하, 무게 2,200kg 이하, 높이 SUV/RV 1,850mm 이하로 주차불가 차량들이 있으므로, 사전에 확인하셔야 합니다.
                </p>
              </div>
              <div class="item_text_sub">
                <p class="tw_pWrap">
                  주차가 만차가 되거나, 주차 불가될 경우, 인근 유료 주차장인 "테헤란로 64길 노상공영주차장 or 샹제리제센터  B동 주차장" 으로 주차 부탁드립니다.
                  (외부 주차장 사용시 주차비 지원하지 않습니다!)
                </p>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_flex">
                <div class="item_img">
                  <img src="@/assets/images/gill3.svg">
                </div>
                <div class="item_text">
                  <h3>주차장 안내</h3>
                </div>
              </div>
              <div class="item_text_sub">
                <!-- <p>주차장 찾기: 승용차 이용시 내비게이션은 "선릉역 7번출구"로 검색하고 오시면
                 주차장 입구가 있습니다. (아래 사진 참고)</p>
                <p>선릉역 7번출구 표시 기둥과 7번출구 계단 사이의 작은 공간으로 들어 오시면 발렛주차 해드립니다.</p> -->
                <div class="item_img_sub">
                  <img src="@/assets/images/parking_1.jpeg">
                </div>
                <div class="item_img_sub">
                  <img src="@/assets/images/parking_2.jpeg">
                </div>
                <div class="item_img_sub">
                  <img src="@/assets/images/parking_3.jpeg">
                </div>
                <div class="item_img_sub">
                  <img src="@/assets/images/parking_4.jpeg">
                </div>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_flex">
                <div class="item_img">
                  <img src="@/assets/images/gill4.svg">
                </div>
                <div class="item_text">
                  <h3>진료시간</h3>
                </div>
              </div>

              <div class="item_text_sub">
                <p>평일 09:00 ~ 18:00</p>
                <p>토요일 09:00 ~ 13:00</p>
                <p>공휴일 휴무</p>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_flex">
                <div class="item_img">
                  <img src="@/assets/images/gill5.svg">
                </div>
                <div class="item_text">
                  <h3>전화번호</h3>
                </div>
              </div>
              <div class="item_text_sub">
                <p><a href="tel:15228775">1522-8775</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
export default {
  data() {
    return {
      transDate: {
        headerName: "오시는 길",
        prevUrl: "/",
      },
      setCount: false,
    };
  },
  created() {
    if (history.pushState !== undefined) {
      history.pushState({}, "", location.href);
      window.onpopstate = () => {
        this.callPrev();
      };
    }
  },
  mounted() {
    if (window.kakao && window.kakao.maps) {
      this.initMap();
    } else {
      const script = document.createElement("script");
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      script.src =
        "https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=d36427201d7875db030cac5e50af11ed&libraries=clusterer";
      document.head.appendChild(script);
    }
  },
  methods: {
    callPrev() {
      if (this.setCount) {
        this.$router.push("/");
      } else {
        history.go(1);
      }
      this.setCount = true;
      // 클로즈 함수 구현
    },
    initMap() {
      const container = document.getElementById("map");
      const options = {
        center: new kakao.maps.LatLng(37.5045682990077, 127.05017705996893),
        level: 3, // 지도의 확대 레벨
      };

      const map = new kakao.maps.Map(container, options);
      // 마커가 표시될 위치입니다
      const markerPosition = new kakao.maps.LatLng(37.5045682990077, 127.05017705996893);

      // 마커를 생성합니다
      const marker = new kakao.maps.Marker({
        position: markerPosition,
      });
      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);
      map.setMapTypeId(kakao.maps.MapTypeId.NORMAL);
    },
    // addScript () {
    //   const script = document.createElement('script')
    //   script.onload = () => kakao.maps.load(this.initMap)
    //   script.src = 'http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=d36427201d7875db030cac5e50af11ed&libraries=clusterer'
    //   document.head.appendChild(script)
    // }
  },
  components: {
    AppHeader,
    AppSidebar,
  },
  beforeDestroy() {
    this.setCount = false;
  },
};
</script>

<style lang="scss" scoped>
#map {
  width: 100%;
  min-height: 200px;
  height: auto;
}
</style>
